import { z } from 'zod';
export const AppraiserFeatureFlagValuesSchema = z.object({
    enable_internal_tasks: z.boolean(),
    enable_invoicing_automation_scripts_execution: z.boolean(),
    enable_full_appraiser_ui_view_mode: z.boolean(),
    enable_appraiser_market_data_search: z.boolean(),
    enable_entries_transfer_automation_script_execution_for_org: z.boolean(),
    enable_external_participants: z.boolean(),
    enable_plausibility_internal_approval: z.boolean(),
});
const AppraiserFeatureFlagsShape = {
    values: AppraiserFeatureFlagValuesSchema,
};
export const AppraiserFeatureFlagsSchema = z.object(AppraiserFeatureFlagsShape);
export const CustomerFeatureFlagValuesSchema = z.object({
    enable_energy_summary: z.boolean(),
    enable_market_data: z.boolean(),
    enable_market_data_demo_data: z.boolean(),
    enable_market_data_from_valuation: z.boolean(),
    enable_comparables_for_customers: z.boolean(),
    enable_actual_rent_in_charts: z.boolean(),
    enable_customer_fine_grained_authorization: z.boolean(),
    enable_external_participants: z.boolean(),
    enable_plausibility_internal_approval: z.boolean(),
    enable_localization: z.boolean(),
    enable_full_appraiser_ui_view_mode: z.boolean(),
});
const CustomerFeatureFlagsShape = {
    values: CustomerFeatureFlagValuesSchema,
};
export const CustomerFeatureFlagsSchema = z.object(CustomerFeatureFlagsShape);
